import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Data Searching',
  content: `
Data Searching in Pliable allows you to quickly locate specific records, entities, or columns across your connected data sources. Use it to audit data, troubleshoot mappings, or find specific values for reporting.

# Searching

The search button is located at the top right of the Pliable interface when in a data source node.

Clicking on the search button will open a window to enter any value. You can search by:

- **Value** (e.g., \`NY\` in a state column)

> 📎  This function supports fuzzy matching (e.g., typing \`cust\` will return customer_id, customers, etc.).
`,
};

export default doc;
